
//DESIGN POUR LES ROLES
import React from 'react';
import clsx from 'clsx';

interface UserRoleBadgeProps {
  role: string;
  className?: string;
}

export const UserRoleBadge: React.FC<UserRoleBadgeProps> = ({ 
  role,
  className 
}) => {
  // Définition des couleurs par type de rôle avec la nouvelle palette
  const roleColors: Record<string, string> = {
    admin: 'bg-c06a70 bg-opacity-10 text-c06a70 border border-c06a70 border-opacity-20',
    administrator: 'bg-c06a70 bg-opacity-10 text-c06a70 border border-c06a70 border-opacity-20',
    manager: 'bg-slate-400 bg-opacity-10 text-slate-600 border border-slate-400 border-opacity-20',
    editor: 'bg-slate-400 bg-opacity-10 text-slate-600 border border-slate-400 border-opacity-20',
    user: 'bg-slate-100 text-slate-500 border border-slate-200',
    default: 'bg-white text-slate-600 border border-slate-200'
  };

  // Normalisation du nom du rôle pour la correspondance
  const normalizedRole = role.toLowerCase().trim();

  // Sélection de la couleur appropriée
  const colorClass = roleColors[normalizedRole] || roleColors.default;

  return (
    <span 
      className={clsx(
        'inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium transition-all duration-200',
        colorClass,
        className
      )}
      title={`Rôle: ${role}`}
    >
      {role}
    </span>
  );
};

// import React from 'react';
// import clsx from 'clsx';

// interface UserRoleBadgeProps {
//   role: string;
//   className?: string;
// }

// export const UserRoleBadge: React.FC<UserRoleBadgeProps> = ({ 
//   role,
//   className 
// }) => {
//   // Définition des couleurs par type de rôle
//   const roleColors: Record<string, string> = {
//     admin: 'bg-red-100 text-red-800',
//     administrator: 'bg-red-100 text-red-800',
//     manager: 'bg-blue-100 text-blue-800',
//     editor: 'bg-green-100 text-green-800',
//     user: 'bg-gray-100 text-gray-800',
//     default: 'bg-purple-100 text-purple-800'
//   };

//   // Normalisation du nom du rôle pour la correspondance
//   const normalizedRole = role.toLowerCase().trim();

//   // Sélection de la couleur appropriée
//   const colorClass = 
//     roleColors[normalizedRole] || 
//     roleColors.default;

//   return (
//     <span 
//       className={clsx(
//         'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
//         colorClass,
//         className
//       )}
//       title={`Rôle: ${role}`}
//     >
//       {role}
//     </span>
//   );
// };